import styled from 'styled-components';
import { getColor } from '@karma/components/colors';
import BaseButton from 'components/atoms/BaseButton/BaseButton';

export const LinkTermsPrivacy = styled(BaseButton)`
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  font-weight: 600;
  color: ${getColor('neutral7')};

  &:hover {
    color: ${getColor('secondary1')};
    text-decoration: underline;
  }
`;
